export class GroupUpdateRequest {
  constructor(
    public name: string,
    public description?: string,
    public inviteActive?: boolean,
  ) {}
}
